export default "__VITE_ASSET__a578c766__"